if (!customElements.get('product-buy-bar')) {
  class ProductBuyBar extends HTMLElement {
    constructor() {
      "use strict";
      super();

      // MIMMTI CRO (4 okt 2026): eerder pakte dit de eerste .product-form op de pagina (vaak een verborgen
      // snelkoop-formulier), waardoor de meescrollende knop nooit verscheen. Nu: de echte koopknop van het product.
      const knop = document.querySelector('.product-form__submit.btn--primary');
      const mainProductForm = (knop && knop.closest('product-form')) || document.querySelector('.product-form');
      if (!mainProductForm) return;

      let knopInBeeld = true;
      let footerInBeeld = false;
      const bijwerken = () => {
        const tonen = !knopInBeeld && !footerInBeeld && window.scrollY > 200;
        this.classList.toggle('show', tonen);
      };

      new IntersectionObserver((entries) => {
        entries.forEach((e) => { knopInBeeld = e.isIntersecting; });
        bijwerken();
      }, { threshold: 0 }).observe(mainProductForm);

      const footer = () => {
        const siteFooter = document.querySelector('footer.footer');
        if (!siteFooter) return;
        new IntersectionObserver((entries) => {
          entries.forEach((e) => { footerInBeeld = e.isIntersecting; });
          bijwerken();
        }).observe(siteFooter);
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', footer); else footer();

      window.addEventListener('scroll', bijwerken, { passive: true });
    }
  }

  customElements.define('product-buy-bar', ProductBuyBar);
}
